import React from 'react'
import { Card, Statistic } from 'antd'
import { AndroidFilled } from '@ant-design/icons'
import { FormComponent } from '../../../../BaseComponent'
import { DashboardProps } from '../types'


export default class DashboardTotal extends FormComponent<DashboardProps> {
  render() {
    return (
      <Card>
        <Statistic
          title="Total"
          value={this.props.context.preview?.total || 0}
          prefix={<AndroidFilled />}
        />
      </Card>
    )
  }
}
